import { Form, Select } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { AiFillDelete, AiOutlineClose, AiOutlinePlus } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import CreateDrawer from "../CRM/CommonUi/CreateDrawer";
import TableComponent from "../CRM/CommonUi/TableComponent";
import CreatePromoForm from "./CreatePromoForm";
import { getPromoCodes, deletePromoCode } from '../../redux/rtk/features/crm/promocode/promoCodeSlice';
import CreatePromo from "./CreatePromo";
import ConfirmModal from "../ConfirmationModal/ConfirmModal";
const PromoCode = () => {
	const columns = [
		{
			title: "ID",
			dataIndex: "id",
			key: "id",
			render: (id) => id ? id : "-",
		},
		{
			title: "Franchise Name",
			dataIndex: "assignee",
			render: (assignee) => assignee?.franchiseName || "-"
		},
		{
			title: "Promocode",
			dataIndex: "promocode",
			render: (promocode) => promocode || "-",
		},
		{
			title: "Amount",
			dataIndex: "amount",
			key: "amount",
			render: (amount) => {
				return `${amount || "0.00"}`
			},
		},
		{
			title: "Start Date",
			dataIndex: "start_date",
			render: (date) => (date ? moment(date).format("MMMM Do YYYY") : "-"),
		},
		{
			title: "End Date",
			dataIndex: "end_date",
			render: (date) => (date ? moment(date).format("MMMM Do YYYY") : "-"),
		},
		{
			title: "Availability",
			dataIndex: "availability",
			render: (availability) => availability || "-",
		},
		{
			title: "Gift Card",
			dataIndex: "isGiftCard",
			render: (isGiftCard) => isGiftCard ? "Yes" : "No" || "-",
		},
		{
			title: "Used",
			dataIndex: "isGiftCardUsed",
			render: (isGiftCardUsed) => isGiftCardUsed ? "Yes" : "No" || "-",
		}, {
			title: "Action",
			dataIndex: "id",
			key: "action",
			render: (id, record) => (
				<div className="flex gap-2">
					<span className="flex items-center gap-2">
						<CreatePromo record={record} />
					</span>
					<span
						onClick={() => {
							setIsModalOpen(true);
							setPromoToDelete(id);
						}}
						className="p-1 cursor-pointer w-8 h-8 flex justify-center items-center rounded"
					>
						<AiFillDelete className="text-[#EF4444] text-xl" />
					</span>
				</div>
			),
		},
	];
	const dispatch = useDispatch();
	const { list, total, isFetchingAll, isDeleting } = useSelector((state) => state.promoCodes);
	const [filteredList, setFilteredList] = useState(list);
	const [open, setOpen] = useState(false);
	const [isFilter, setFilter] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [promoToDelete, setPromoToDelete] = useState(null);

	useEffect(() => {
		setFilteredList(list)
	}, [list])
	// Fetch promo codes on component load
	useEffect(() => {
		dispatch(getPromoCodes({ page: 1, pageSize: 10 }));
	}, [dispatch]);

	const onClose = () => {
		setOpen(false);
	};

	const filterToggle = () => {
		setFilter((prev) => !prev);
	};

	const handleOk = async () => {
		try {
			await dispatch(deletePromoCode(promoToDelete)).unwrap();
			dispatch(getPromoCodes());
			setIsModalOpen(false);
		} catch (error) {
			console.error(error);
		}
	};

	const handleCancel = () => {
		setIsModalOpen(false);
		setPromoToDelete(null);
	};

	// Basic Search 
	function handleSearch(value) {
		if (value === "") {
			setFilteredList(list)
		} else {
			const filteredPromoCodes = list.filter((promoCode) => {
				return promoCode?.promocode?.toLowerCase().includes(value.toLowerCase()) || promoCode?.assignee?.franchiseName?.toLowerCase().includes(value.toLowerCase())
			})
			setFilteredList(filteredPromoCodes)
		}
	}

	return (
		<div className='px-4'>
			<div className='bg-white dark:bg-DTableBg flex flex-row justify-between items-center gap-3 filter-wrapper border-radius-top table-top-padding'>
				<div className="flex items-center">
					<h2 className="text-xl lg:text-2xl font-semibold">Promocode List</h2>
				</div>
				<div className="flex flex-col sm:flex-row sm:items-center sm:gap-[12px]">
					{/* <div className='flex sm:justify-end sm:items-center gap-5'>
						<button
							onClick={filterToggle}
							className={`hidden md:block ${
								isFilter ? "btn-secondary" : "btn-secondary rounded-[1.25rem]"
							}  px-5 py-2 rounded cursor-pointer rounded-[1.25rem]`}
							type='submit'>
							{isFilter ? (
								<span className='flex justify-center items-center gap-2'>
									<AiOutlineClose /> Close
								</span>
							) : (
								<span className=''>Filter</span>
							)}
						</button>
						{!isFilter ? (
							<CrmSearch className="hidden lg:block" paginatedThunk={loadAllQuotePaginated} />
						) : (
							<div className='flex text-md'>
								<Form
									className='flex flex-wrap justify-center gap-2 md:items-center'
									form={form}
									onFinish={onFinish}
									onFinishFailed={onFinishFailed}
									layout='inline'
									initialValues={{
										status: ["true"],
									}}>
									<Form.Item name='quoteOwner' className='w-full md:w-[180px]'>
										<Select
											mode='multiple'
											style={{ width: "100%" }}
											placeholder='Select Owner'
											maxTagCount={0}
											maxTagPlaceholder={<div className='w-[150px]'>Owner</div>}>
											{quoteOwner?.map((item) => (
												<Option key={item.id} value={item.id}>
													{item?.firstName} {item?.lastName}
												</Option>
											))}
										</Select>
									</Form.Item>

									<Form.Item name='quoteStage' className='w-full md:w-[180px]'>
										<Select
											mode='multiple'
											style={{ width: "100%" }}
											placeholder='Select Stage'
											maxTagCount={0}
											maxTagPlaceholder={<div className='w-[150px]'>Stage</div>}>
											{quoteStage?.map((item) => (
												<Option key={item.id} value={item.id}>
													{item.quoteStageName}
												</Option>
											))}
										</Select>
									</Form.Item>

									<Form.Item name='contact' className='w-full md:w-[180px]'>
										<Select
											mode='multiple'
											style={{ width: "100%" }}
											placeholder='Select contact'
											maxTagCount={0}
											maxTagPlaceholder={
												<div className='w-[150px]'>Contact</div>
											}>
											{contact?.map((item) => (
												<Option key={item.id} value={item.id}>
													{item?.firstName} {item?.lastName}
												</Option>
											))}
										</Select>
									</Form.Item>
									<Form.Item name='company' className='w-full md:w-[180px]'>
										<Select
											mode='multiple'
											style={{ width: "100%" }}
											placeholder='Select Company'
											maxTagCount={0}
											maxTagPlaceholder={
												<div className='w-[150px]'>Company</div>
											}>
											{company?.map((item) => (
												<Option key={item.id} value={item.id}>
													{item.companyName}
												</Option>
											))}
										</Select>
									</Form.Item>
									<Form.Item name='opportunity' className='w-full md:w-[180px]'>
										<Select
											mode='multiple'
											style={{ width: "100%" }}
											placeholder='Select Opportunity'
											maxTagCount={0}
											maxTagPlaceholder={
												<div className='w-[150px]'>Opportunity</div>
											}>
											{opportunity?.map((item) => (
												<Option key={item.id} value={item.id}>
													{item.opportunityName}
												</Option>
											))}
										</Select>
									</Form.Item>
									<Form.Item name='status' className='w-full md:w-[180px]'>
										<Select
											mode='multiple'
											style={{ width: "100%" }}
											placeholder='Please select'
											defaultValue={["true"]}>
											<Option value='true'>True</Option>
											<Option value='false'>False</Option>
										</Select>
									</Form.Item>
									<Form.Item>
										<div className='w-full md:w-[180px] flex justify-start'>
											<button
												className='custom-filter-btn text-white px-5 py-2 rounded cursor-pointer'
												type='submit'>
												Filter
											</button>
											<button
												onClick={filterToggle}
												className='block md:hidden  px-5 py-2 rounded cursor-pointer ml-2 text-rose-700 transition-colors duration-150 border border-rose-500 focus:shadow-outline hover:bg-rose-500 hover:text-rose-100'>
												Cancel
											</button>
										</div>
									</Form.Item>
								</Form>
							</div>
						)}
					</div> */}
					{!isFilter && (
						<UserPrivateComponent permission='create-quote'>
							<button
								onClick={() => setOpen(true)}
								className='py-2 px-2 md:px-6 btn-primary cursor-pointer flex items-center gap-2 w-max text-[10px] md:text-[14px]'>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="plus-icon">
									<path stroke="white" fill-rule="evenodd" d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd" />
								</svg>
								<span className="text-white text-[10px] md:text-[14px] font-semibold">Add Promocode</span>
							</button>
						</UserPrivateComponent>
					)}
				</div>
			</div>
			<UserPrivateComponent permission='readAll-quote'>
				<TableComponent
					list={filteredList}
					csvList={filteredList.map(({ assignee, ...rest }) => ({ ...rest, franchiseName: assignee?.franchiseName }))}
					total={total}
					loading={isFetchingAll}
					columns={columns}
					csvFileName={"PromoCode-List"}
					rowClassName={(record, index) =>
						index % 2 === 0 ? "even-row" : "odd-row"
					}
					handleSearch={handleSearch}
				/>
			</UserPrivateComponent>

			<UserPrivateComponent permission='create-quote'>
				<CreateDrawer onClose={onClose} open={open} title={"Add Promocode"}>
					<CreatePromoForm onClose={onClose} open={open} />
				</CreateDrawer>
			</UserPrivateComponent>

			<ConfirmModal
				title="Delete Promo Code"
				loading={isDeleting}
				message="Are you sure you want to delete this promo code?"
				open={isModalOpen}
				handleCloseModal={() => setIsModalOpen(false)}
				handleOk={handleOk}
				handleCancel={handleCancel}
				okText="Delete"
				cancelText="Cancel"
			/>
		</div>
	);
};
export default PromoCode;
